import $ from 'jquery';

const stash = window.Stash['widgets/jix_slider'];

function changeHandler() {
    const elem = this;

    const min = elem.getAttribute('min');
    const max = elem.getAttribute('max');
    const diff = max - min;
    const pct = ((elem.value - min) / diff) * 100;

    elem.style.setProperty('--jix-slider-pct', `${pct}%`);
}

function init() {
    stash.forEach(({ stash }) => {
        const elem = document.getElementById(stash.id);
        changeHandler.call(elem);
        ['input', 'change'].forEach(x => elem.addEventListener(x, changeHandler));
    });
}

$(init);
